var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widM padTM pf23Wrap padBML" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "p",
      {
        staticClass: "pf23-tit fntH4 fntL bold marBS padTML txtC",
        staticStyle: { color: "#00305e", "letter-spacing": "normal" }
      },
      [_vm._v("신청이 완료되었습니다.")]
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticClass: "pf23-tit fntH4 marBL txtC",
        staticStyle: { color: "#2c2c2c", "letter-spacing": "normal" }
      },
      [_vm._v("아래 신청 내용을 확인해 주세요.")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pf23-inFo-wrap" }, [
      _c(
        "div",
        { staticClass: "widM clearfix" },
        [
          _vm._l(_vm.attendingList, function(attend, idx) {
            return [
              idx > 0
                ? _c("hr", {
                    key: "hr-" + idx,
                    staticClass: "moOnly",
                    staticStyle: {
                      "border-top": "1px solid #ddd",
                      background: "#f4f4f4",
                      padding: "5px 0"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  key: idx,
                  staticClass: "widM",
                  class: { floL: idx == 0, floR: idx == 1 }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "fntH6 fntL bold marBM",
                      staticStyle: { color: "#2c2c2c", width: "49%" }
                    },
                    [_vm._v(_vm._s(_vm.aboType(idx)))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "fntP", attrs: { for: "pf23Name01" } },
                        [_vm._v("이름")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Name01",
                          name: "pf23Name01"
                        },
                        domProps: { value: _vm.aboName(idx) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "fntP", attrs: { for: "pf23Abo01" } },
                        [_vm._v("ABO 번호")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Abo01",
                          name: "pf23Abo01"
                        },
                        domProps: { value: _vm.aboNumber(idx) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "fntP", attrs: { for: "pf23Num01" } },
                        [_vm._v("휴대폰 번호")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Num01",
                          name: "pf23Num01"
                        },
                        domProps: { value: "010-" + _vm.answer(idx, "Q031") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "fntP", attrs: { for: "pf23Num01" } },
                        [_vm._v("내국인 구분")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Num01",
                          name: "pf23Num01"
                        },
                        domProps: { value: _vm.domestic(idx, "Q032") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pf23-complet-common padBSM padTSM pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          staticStyle: { width: "45%" },
                          attrs: { for: "pf23Personal01-1" }
                        },
                        [_vm._v(_vm._s(_vm.country(idx, "Q032")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "em",
                        {
                          staticClass: "txtR disIb",
                          staticStyle: { width: "55%" }
                        },
                        [
                          _c("input", {
                            staticStyle: { width: "45%" },
                            attrs: {
                              type: "text",
                              name: "pf23Personal01-1",
                              id: "pf23Personal01-1",
                              maxlength: "6",
                              oninput:
                                "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');"
                            },
                            domProps: { value: _vm.answer(idx, "Q033_1") }
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "disIb txtC",
                              staticStyle: { width: "10%" }
                            },
                            [_vm._v("-")]
                          ),
                          _c("input", {
                            staticStyle: { width: "45%" },
                            attrs: {
                              type: "text",
                              id: "pf23Personal01-1-2",
                              name: "pf23Personal01-1",
                              maxlength: "7",
                              oninput:
                                "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');"
                            },
                            domProps: { value: _vm.answer(idx, "Q033_2") }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          attrs: { for: "pf23en-first01" }
                        },
                        [_vm._v("영문 성")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23en-first01",
                          name: "pf23en-first01"
                        },
                        domProps: { value: _vm.answer(idx, "Q034_1") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          attrs: { for: "pf23en-name01" }
                        },
                        [_vm._v("영문 이름")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23en-name01",
                          name: "pf23en-name01"
                        },
                        domProps: { value: _vm.answer(idx, "Q034_2") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          attrs: { for: "pf23-gender01" }
                        },
                        [_vm._v("성별")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23-gender01",
                          name: "pf23-gender01"
                        },
                        domProps: { value: _vm.gender(idx, "Q035") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          attrs: { for: "pf23-country01" }
                        },
                        [_vm._v("국가")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23-country01",
                          name: "pf23-country01"
                        },
                        domProps: { value: _vm.answer(idx, "Q036") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          attrs: { for: "pf23Passport-Num01" }
                        },
                        [_vm._v("여권번호")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Passport-Num01",
                          name: "pf23Passport-Num01"
                        },
                        domProps: { value: _vm.answer(idx, "Q037") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          attrs: { for: "pf23Passport-issu01" }
                        },
                        [_vm._v("여권발급일")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Passport-issu01",
                          name: "pf23Passport-issu01"
                        },
                        domProps: { value: _vm.answer(idx, "Q038") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          attrs: { for: "pf23Passport-date01" }
                        },
                        [_vm._v("여권만료일")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Passport-date01",
                          name: "pf23Passport-date01"
                        },
                        domProps: { value: _vm.answer(idx, "Q039") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fntP",
                          attrs: { for: "pf23Passport-date01" }
                        },
                        [_vm._v("안전확인")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Passport-date01",
                          name: "pf23Passport-date01"
                        },
                        domProps: { value: _vm.booleanAnswer(idx, "Q040") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "fntP", attrs: { for: "pf23Active01" } },
                        [_vm._v("Day-3 액티비티")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Active01",
                          name: "pf23Active01"
                        },
                        domProps: { value: _vm.activityAnswer(idx, "Q029") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "padBSM padTSM pf23-complet-common pf23-lineBtm",
                      class: {
                        "pf23-complet-L": idx == 0,
                        "pf23-complet-R": idx == 1
                      }
                    },
                    [
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          id: "pf23Return01",
                          name: "pf23Return01"
                        },
                        domProps: { value: _vm.scheduleAnswer(idx, "Q030") }
                      })
                    ]
                  )
                ]
              )
            ]
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "widM txtC marTML" }, [
      _c(
        "button",
        {
          staticClass: "bt-akl-blue large pf23-submit",
          on: {
            click: function($event) {
              return _vm.$emit("edit", true)
            }
          }
        },
        [_vm._v("수정하기")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "txtC padTS moTxtL" }, [
        _vm._v(
          "* 본 화면을 벗어나더라도 신청기간 내에 URL을 통해 다시 수정하실 수 있습니다."
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "txtC padBM",
        staticStyle: { "border-bottom": "1px solid #ddd" }
      },
      [
        _c("img", {
          staticClass: "icoS",
          staticStyle: { "max-width": "115px" },
          attrs: {
            src:
              "https://www.amway.co.kr/_ui/_noticeImg/logo/logo_amway_ci.png",
            alt: "Amway (로고)"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23Return01" } },
      [_vm._v("귀국일"), _c("br"), _c("em", [_vm._v("(싱가포르 - 한국)")])]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cec6c55a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cec6c55a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/singapore/components/SurveyCompleted.vue
// module id = null
// module chunks = 